import { NSBanner, NSButtonBlue, NSColumn, NSRow, NSSection, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import { EncodingOperation } from 'namirasoft-core';
import { PaymentRoutes } from '../PaymentRoutes';

export interface PaymentCanceledPageProps extends NSARouterMakerResult, PaymentProps
{ }

function PaymentCanceledPage(props: PaymentCanceledPageProps)
{
	return (
		<PaymentLayout {...props}
			action={{
				title: "Payment failed", description: ""
			}}
		>
			<NSSection>
				<NSColumn>
					<NSRow>
						<NSBanner
							imageLeft={{
								src: "https://static.namirasoft.com/image/concept/bot/upset.png",
								alt: "upset bot"
							}}
							imageRight={null}
							title={{
								text: "We couldn't process your payment!",
								style: {
									color: "rgba(255, 63, 63, 1)",
									fontWeight: "bold"
								}
							}}
						/>
					</NSRow>
				</NSColumn>
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<p>
					Unfortunately, we couldn't complete your payment. This may be due to one of the following reasons:
					<NSSpace size={NSSpaceSizeType.NANO} />
					<li>You canceled the payment.</li>
					<li>There was an issue with the payment gateway.</li>
					<li>A technical problem occurred on our end.</li>
					<NSSpace size={NSSpaceSizeType.NANO} />
					If the amount was deducted from your account but isn't reflected in your order, please contact our support team at <a href="https://support.namirasoft.com">support.namirasoft.com</a>.
					<br />
					We'll assist you as soon as possible.
				</p>
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				<NSButtonBlue
					title='Back'
					onClick={{
						action: () =>
						{
							let callback = props.url.getQuery("callback");
							if (callback)
								try
								{
									callback = EncodingOperation.Base64Decode(callback);
								} catch (error)
								{
									callback = "";
								}
							if (!callback)
								props.url.redirect(PaymentRoutes.PaymentList(false, ""), {});
							else
								window.location.href = callback;
						},
						showLoading: false
					}}
				/>
			</NSSection>
		</ PaymentLayout >
	);
}

export default PaymentCanceledPage;